"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentPackagesReducer = exports.initialState = void 0;
/* Package Imports */
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var actions = __importStar(require("./actions"));
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var transfersActions = __importStar(require("@app/features/transfers/state/actions"));
var constants_1 = require("@server/shared/constants");
var api_1 = require("@server/types/api");
exports.initialState = {
    currentOffset: 0,
    isSearching: false,
    packages: [],
    refreshPackages: false,
    selectedUsers: [],
    sortDirection: -1,
    sortKey: constants_1.creationDateSortField,
    totalPackagesCount: 0,
    userFilters: []
};
var sentPackagesReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Sent Packages actions
        case typesafe_actions_1.getType(actions.getSearchFiltersSuccess):
            return __assign(__assign({}, state), { userFilters: action.payload });
        case typesafe_actions_1.getType(actions.getSentPackagesSuccess):
            return __assign(__assign({}, state), { packages: action.payload.appendRows ? __spreadArray(__spreadArray([], state.packages), utils_1.mapPackagesToModel(action.payload.packages)) :
                    utils_1.mapPackagesToModel(action.payload.packages), refreshPackages: false });
        case typesafe_actions_1.getType(actions.refreshSentPackages):
            return __assign(__assign({}, state), { refreshPackages: true });
        case typesafe_actions_1.getType(actions.setIsSearching):
            return __assign(__assign({}, state), { isSearching: action.payload });
        case typesafe_actions_1.getType(actions.toggleSelectUser): {
            if (state.selectedUsers.indexOf(action.payload) > -1) {
                return __assign(__assign({}, state), { selectedUsers: state.selectedUsers.filter(function (u) { return u !== action.payload; }) });
            }
            else {
                return __assign(__assign({}, state), { selectedUsers: __spreadArray(__spreadArray([], state.selectedUsers), [action.payload]) });
            }
        }
        case typesafe_actions_1.getType(actions.updateCurrentOffset):
            return __assign(__assign({}, state), { currentOffset: action.payload });
        case typesafe_actions_1.getType(actions.updateSort):
            return __assign(__assign({}, state), { sortKey: action.payload.sortKey, sortDirection: action.payload.sortDirection });
        case typesafe_actions_1.getType(actions.updateTotalCount):
            return __assign(__assign({}, state), { totalPackagesCount: action.payload });
        // Transfers actions
        case typesafe_actions_1.getType(transfersActions.updateTransfer):
            // Update the state of any sent packages
            return __assign(__assign({}, state), { packages: state.packages.map(function (p) {
                    return ((action.payload.packageId && action.payload.packageId === p.id) ||
                        moment_1.default(action.payload.creationDate).isSame(p.creationDate)) && (p.pkgState !== models_1.PackageState.DELETED && p.pkgState !== models_1.PackageState.EXPIRED) ? __assign(__assign({}, p), { totalBytes: action.payload.totalSize, transferredBytes: action.payload.transferredBytes, state: (action.payload.direction === api_1.Direction.SEND) ?
                            (p.state === undefined && action.payload.state === models_1.PackageTransferState.COMPLETE) ? undefined : action.payload.state :
                            undefined, packageTransferId: (action.payload.direction === api_1.Direction.SEND && action.payload.transferId) ? action.payload.transferId : '', errorCode: action.payload.errorCode, errorDesc: action.payload.errorDesc, errorMsg: action.payload.state === models_1.PackageTransferState.FAILED ? 'Error downloading the package' : '' }) : p;
                }) });
        default:
            return state;
    }
};
exports.sentPackagesReducer = sentPackagesReducer;
